/**
 * StingBase
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { HttpHeaders }                                       from '@angular/common/http';

import { Observable }                                        from 'rxjs';

import { CreateFinMathRequest } from '../model/models';
import { InlineObject } from '../model/models';
import { InlineObject1 } from '../model/models';


import { Configuration }                                     from '../configuration';



export interface MathServiceInterface {
    defaultHeaders: HttpHeaders;
    configuration: Configuration;

    /**
     * Investment calc
     * 
     * @param createFinMathRequest 
     */
    finMathInvestment(createFinMathRequest: CreateFinMathRequest, extraHttpRequestParams?: any): Observable<Array<any>>;

    /**
     * Mortgage calc
     * 
     * @param createFinMathRequest 
     */
    finMathMortgage(createFinMathRequest: CreateFinMathRequest, extraHttpRequestParams?: any): Observable<Array<any>>;

}
